import mapTemplateDataFromApi from './mapTemplateDataFromApi';

export default ({ data, meta: { count }, included }) => ({
  itemList: data.map(item => mapTemplateDataFromApi(item, included)),
  totalCount: count,
});
